import { createContext, useState } from "react";
import { ContextProviderProps } from "../../../types";
import { DozvolaTipObjekta } from "../exciseLicences/exciseLicences.types";
import {
  ExciseWarehouseState,
  UpdateWarehouseFunction,
} from "./exciseWarehouse.types";

export const initialState = (): ExciseWarehouseState => {
  return {
    //Response for istorijaZahtevaZaSkladiste

    istorijaZahtevaZaSkladiste: [],

    //Response for istorijaResenjaZaSkladiste

    istorijaResenjaZaSkladiste: [],

    //Payload for kreiranjeZahtevaZaIzmenuObnovuIliPrekidVazenjaDozvole

    tipZahteva: null,
    zahtev: {
      tipDozvole: DozvolaTipObjekta.PROIZVODNJA_SA_SKLADISTEM,
      dokumentiZaDozvolu: [],
      dozvolaInformacije: {
        tarifnaOznaka: "",
        kategorijaProizvodaId: null,
        ulicaProizvodnje: "",
        brojUliceProizvodnje: "",
        postanskiBrojProizvodnje: "",
        mestoProizvodnje: "",
        kolicinaUskladistenihProizvoda: null,
        prosecanMesecniRashod: null,
        nacinOtpremanja: "",
        podatakOMernimUredjajima: "",
        brojResenja: "",
        datumResenjaNadleznogOrgana: null,
        planiranaProizvodnjaProizvodaKomadi: null,
      },
      skladisteInformacije: {
        skladisteId: null,
        kolicinaProizvodaIzPrethodneGodine: null,
        planiranaProizvodnjaProizvoda: null,
        brojSkladistaZaDozvolu: "",
        ulicaSkladista: "",
        brojUliceSkladista: "",
        postanskiBrojSkladista: "",
        mestoSkladista: "",
        oznakaSkladista: "",
        opisSkladista: "",
        opisRadaRacunovodstva: "",
        meraVelicineSkladista: null,
        meraVrednost: null,
      },
    },

    //Response for kreiranjeZahtevaZaIzmenuObnovuIliPrekidVazenjaDozvole

    id: null,

    //SelectedWarehouse

    selectedWarehouseId: null,
  };
};

interface IExciseWarehouseContext {
  exciseWarehouse: ExciseWarehouseState;
  setExciseWarehouse: UpdateWarehouseFunction;
  clearWarehouseState: () => void;
  clearPayloadState: () => void;
}

export const ExciseWarehouseContext = createContext<IExciseWarehouseContext>(
  null as any
);

export const ExciseWarehouseContextProvider = ({
  children,
}: ContextProviderProps) => {
  const [exciseWarehouse, setExciseWarehouseState] = useState(initialState());

  const handleSetWarehouse = (updatedState: Partial<ExciseWarehouseState>) => {
    const newState = { ...exciseWarehouse, ...updatedState };
    setExciseWarehouseState(newState);
  };

  const setExciseWarehouse = (updatedState: Partial<ExciseWarehouseState>) => {
    handleSetWarehouse({ ...updatedState });
  };

  const clearWarehouseState = () => {
    setExciseWarehouseState(initialState());
  };

  const clearPayloadState = () => {
    const updatedState: Partial<ExciseWarehouseState> = {
      zahtev: {
        tipDozvole: DozvolaTipObjekta.PROIZVODNJA_SA_SKLADISTEM,
        dokumentiZaDozvolu: [],
        dozvolaInformacije: {
          tarifnaOznaka: "",
          kategorijaProizvodaId: null,
          ulicaProizvodnje: "",
          brojUliceProizvodnje: "",
          postanskiBrojProizvodnje: "",
          mestoProizvodnje: "",
          kolicinaUskladistenihProizvoda: null,
          prosecanMesecniRashod: null,
          nacinOtpremanja: "",
          podatakOMernimUredjajima: "",
          brojResenja: "",
          datumResenjaNadleznogOrgana: null,
          planiranaProizvodnjaProizvodaKomadi: null,
        },
        skladisteInformacije: {
          skladisteId: null,
          kolicinaProizvodaIzPrethodneGodine: null,
          planiranaProizvodnjaProizvoda: null,
          brojSkladistaZaDozvolu: "",
          ulicaSkladista: "",
          brojUliceSkladista: "",
          postanskiBrojSkladista: "",
          mestoSkladista: "",
          oznakaSkladista: "",
          opisSkladista: "",
          opisRadaRacunovodstva: "",
          meraVelicineSkladista: null,
          meraVrednost: null,
        },
      },
    };
    setExciseWarehouse(updatedState);
  };

  return (
    <ExciseWarehouseContext.Provider
      value={{
        exciseWarehouse,
        setExciseWarehouse,
        clearWarehouseState,
        clearPayloadState,
      }}
    >
      {children}
    </ExciseWarehouseContext.Provider>
  );
};
